import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts/highstock';

@Component({
  selector: 'smart-highchart',
  templateUrl: './highchart.component.html',
  styleUrls: ['../graph-color.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HighchartComponent implements OnChanges {
  @Input() sensorLeft = [];
  @Input() sensorRight = [];
  colorSetting = [
    "",
    "#7cb6ec",
    "#8085e9",
    "#434348",
    "#90ed7d"
  ];
  filter: boolean = false;
  Highcharts: typeof Highcharts = Highcharts;

  chartOptions: Highcharts.Options = {
    chart: {
      scrollablePlotArea: {
        minWidth: 600,
        scrollPositionX: 1
      },
      zoomType: 'x'
    },
    plotOptions: {
      series: {
        showInNavigator: true
      },
      spline: {
        lineWidth: 3,
        states: {
          hover: {
            lineWidth: 4
          }
        },
        marker: {
          enabled: true,
          radius: 4
        }
      }
    },
    legend: {
      enabled: true
    },
    rangeSelector:{
      selected: 4
    },
    yAxis: [],
    tooltip: {
      shared: true
    },
    series: [],
    xAxis: {
      type: 'datetime',
    },
    scrollbar: {
      enabled: true
    },
    exporting:{
      enabled: false
    }
  };
  noData: boolean = false;

  constructor(
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.filter = false;
    this.plotGraph();
  }

  async plotGraph(){

    let yAxis = [];
    let series = [];

    await Promise.all(this.sensorLeft.map(async sensor=>{
      if(yAxis.find(y=>y.opposite == false && y.sensor_unit == sensor.sensor_unit)){

      }else{
        yAxis.push(
          {
            gridLineWidth: 0,
            title: {
                text: sensor.sensor_name,
                style: {
                    color: this.colorSetting[yAxis.length+1]
                }
            },
            labels: {
              format: '{value} ' + sensor.sensor_unit,
              style: {
                color: this.colorSetting[yAxis.length+1]
              }
            },
            sensor_unit: sensor.sensor_unit,
            opposite:false,
          }
        );
      }
    
      let data = [];

      await Promise.all(sensor.value.map(async v=>{
        await Promise.all(v.dataset.map(async dataset=>{
          if(typeof dataset.value === 'string' || dataset.value == null){
           
          }else{
            data.push(
              [new Date(dataset.receive_date).getTime(), parseFloat(dataset.value)]
            )
          }
        }));
      }));

      series.push(
        {
          name: sensor.sensor_name,
          data: data,
          tooltip: {
            valueSuffix: ' ' + sensor.sensor_unit
          },
          color: this.colorSetting[series.length+1],
          sensor_unit: sensor.sensor_unit,
          opposite: false
        }
      )
    }));
    
    await Promise.all(this.sensorRight.map(async sensor=>{
      if(yAxis.find(y=>y.opposite == true && y.sensor_unit == sensor.sensor_unit)){

      }else{
        yAxis.push(
          {
            gridLineWidth: 0,
            title: {
                text: sensor.sensor_name,
                style: {
                    color: this.colorSetting[yAxis.length+1]
                }
            },
            labels: {
                format: '{value} ' + sensor.sensor_unit,
                style: {
                    color: this.colorSetting[yAxis.length+1]
                }
            },
            sensor_unit: sensor.sensor_unit,
            opposite: true
          }
        );
      }
      let data = [];
      
      await Promise.all(sensor.value.map(async v=>{
        await Promise.all(v.dataset.map(async dataset=>{
          if(typeof dataset.value === 'string' || dataset.value == null){
           
          }else{
            data.push(
              [new Date(dataset.receive_date).getTime(), parseFloat(dataset.value)]
            )
          }
        }));
      }));

      series.push(
        {
          name: sensor.sensor_name,
          data: data,
          tooltip: {
            valueSuffix: ' ' + sensor.sensor_unit
          },
          color: this.colorSetting[series.length+1],
          sensor_unit: sensor.sensor_unit,
          opposite: true
        }
      )
    }));

    await Promise.all(series.map(async (item, index)=>{
      let findIndex = yAxis.findIndex(y=> y.opposite == item.opposite && item.sensor_unit == y.sensor_unit);

      series[index].yAxis = findIndex;
    }));

    await Promise.all(yAxis.map(async (item, index)=>{
      let findSeries = series.find(s=> s.opposite == item.opposite && item.sensor_unit == s.sensor_unit);

      yAxis[index].title.style.color = findSeries.color;
      yAxis[index].labels.style.color = findSeries.color;
    }));

    this.chartOptions.yAxis = yAxis;
    this.chartOptions.series = series;

    this.noData = false;

    if(yAxis.length > 0){
      setTimeout(() => {
        this.loadFilter();
      }, 200);
    }else{
      this.noData = true;
      this.loadFilter();
    }
  }

  loadFilter(){
    this.filter = true;
    this.cd.detectChanges();
  }
}
